import {DossierT100} from "./base.model";

export class FIOType {
  lastName: DossierT100 = '';
  firstName: DossierT100 = '';
  middleName?: DossierT100 = '';
}
